// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"ceb57215","92":"de810f8b","102":"234a704f","232":"9c0ee6e5","348":"2c82fff3","366":"195c0dba","603":"03cfebe3","938":"49e8d2a6"}[chunkId] + ".chunk.js";
};